var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskPoussiere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.909 5.333)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.203,
    cy: 5.203,
    r: 5.203,
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.667,
    cy: 5.203,
    r: 5.203,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.13,
    cy: 5.203,
    r: 5.203,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.203,
    cy: 26.667,
    r: 5.203,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.667,
    cy: 26.667,
    r: 5.203,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.13,
    cy: 26.667,
    r: 5.203,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.203,
    cy: 48.13,
    r: 5.203,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.667,
    cy: 48.13,
    r: 5.203,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.13,
    cy: 48.13,
    r: 5.203,
    fill: "#E74536"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgRiskPoussiere as ReactComponent };